import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Handler, Renderer} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {RadioButton} from '../../../../../libs/shared/ui/src/components/booleanInputs/radioButton';
import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

export interface ModalFilterItemProps {
  id: string;
  value: ReactNode;
  isChecked: boolean;
  onSelect: Handler;
  renderDropdown?: Renderer;
}

/*
 * Style.
 */

const ModalFilterItemWrapperDiv = styled.div`
  padding: 8px;
`;

const ModalFilterValueSpan = styled.span<{$isChecked: boolean}>`
  font-weight: ${(p) => (p.$isChecked ? fontWeights.bold : fontWeights.normal)};
`;

const DropdownWrapperDiv = styled.div`
  margin-top: 8px;
  margin-left: 24px;
  width: fit-content;
  max-width: 236px;
`;

/*
 * Component.
 */

export const ModalFilterItem: FC<ModalFilterItemProps> = (props) => {
  const {isChecked, value, onSelect, renderDropdown} = props;

  return (
    <ModalFilterItemWrapperDiv>
      <RadioButton isChecked={isChecked} onChange={onSelect}>
        <ModalFilterValueSpan $isChecked={isChecked}>{value}</ModalFilterValueSpan>
      </RadioButton>
      {renderDropdown && <DropdownWrapperDiv>{renderDropdown()}</DropdownWrapperDiv>}
    </ModalFilterItemWrapperDiv>
  );
};
